// extracted by mini-css-extract-plugin
module.exports = {"entering":"transition-fade-module--entering--2HMew","entered":"transition-fade-module--entered--KW16D","exiting":"transition-fade-module--exiting--2-vwg"};